import React, { useReducer } from "react";
import formStore, { formClearData } from "../formStore";
import formReducer from "../formStore/reducer";
import { useEffect } from "react";
import { FormComponent } from "./styles";
import ShowError from "~/utils/ShowError";

/**
 * @param {Object} props
 * @param {Function} props.clearData Limpa o estado do formulário.
 * @param {Function} props.onSubmit
 * @param {Function} props.isFormData
 * @param {Function} props.setter Obtém o estado do formulário a cada alteração.
 */
export default function Form({
  children,
  isFormData,
  clearData,
  onSubmit,
  setter,
  ...rest
}) {
  const [state, dispatch] = useReducer(formReducer, {});
  const ref = React.useRef();

  function formatFieldName(fieldName) {
    const withSpaces = fieldName.replace(/([A-Z])/g, ' $1');
    const capitalized = withSpaces.replace(/\b\w/g, letter => letter.toUpperCase());
    return capitalized.trim();
  }

  function handleGetInvalidFields(event) {
    const form = event.target;
    const invalidFields = form.querySelectorAll(':invalid');
    const invalidFieldNames = [];

    invalidFields.forEach(field => {
      const name = field.getAttribute('name');
      const findName = invalidFieldNames.find(item => item === name);

      if (!findName) {
        invalidFieldNames.push(name);
      }
    });

    return invalidFieldNames;
  }

  function handleSubmit(e) {
    e.preventDefault();

    const invalidFieldNames = handleGetInvalidFields(e)
    if (invalidFieldNames.length > 0) {
      const invalidFieldNamesFormatted = invalidFieldNames.map(item => formatFieldName(item));

      const modalText = `Por favor, preencha os seguintes campos obrigatórios:\n\n -${invalidFieldNamesFormatted.join('\n- ')}`;
      ShowError(modalText)
      return
    }

    onSubmit && onSubmit(isFormData ? new FormData(ref.current) : state);
  }

  useEffect(() => {
    setter && setter(state);
  }, [setter, state]);

  useEffect(() => {
    clearData && clearData(() => dispatch(formClearData()));
  }, [clearData]);

  return (
    <formStore.Provider value={{ state, dispatch }}>
      <FormComponent ref={ref} {...rest} onSubmit={handleSubmit}>
        {children}
      </FormComponent>
    </formStore.Provider> 
  );
}
